import {
  INTEGRATIONS_FETCH_EMAILS_REQUEST,
  INTEGRATIONS_FETCH_EMAILS_SUCCESS,
  INTEGRATIONS_FETCH_EMAILS_FAILURE,
  INTEGRATIONS_FETCH_EMAIL_DETAIL_REQUEST,
  INTEGRATIONS_FETCH_EMAIL_DETAIL_SUCCESS,
  INTEGRATIONS_FETCH_EMAIL_DETAIL_FAILURE,
} from '@core/constants/actions';
import {
  getConnectedEmails,
  getConnectedEmailDetail,
  IntegrationProvider,
} from '@core/api/integrations/integrationsApi';
import { AulaThunkAction } from '@core/types/state';

export const fetchConnectedEmails =
  (
    provider: IntegrationProvider,
    options?: { folder?: string; top?: number }
  ): AulaThunkAction<Promise<void>> =>
  async (dispatch) => {
    dispatch({ type: INTEGRATIONS_FETCH_EMAILS_REQUEST });
    try {
      const { emails } = await getConnectedEmails(provider, options);
      dispatch({
        type: INTEGRATIONS_FETCH_EMAILS_SUCCESS,
        emails,
      });
    } catch (err: any) {
      dispatch({
        type: INTEGRATIONS_FETCH_EMAILS_FAILURE,
        error: err?.message || 'Failed to fetch connected emails',
      });
    }
  };

export const fetchConnectedEmailDetail =
  (provider: IntegrationProvider, id: string): AulaThunkAction<Promise<void>> =>
  async (dispatch) => {
    dispatch({ type: INTEGRATIONS_FETCH_EMAIL_DETAIL_REQUEST });
    try {
      const { email } = await getConnectedEmailDetail(provider, id);
      dispatch({
        type: INTEGRATIONS_FETCH_EMAIL_DETAIL_SUCCESS,
        email,
      });
    } catch (err: any) {
      dispatch({
        type: INTEGRATIONS_FETCH_EMAIL_DETAIL_FAILURE,
        error: err?.message || 'Failed to fetch email detail',
      });
    }
  };
